import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { Observable } from 'rxjs';

import { ReportsService } from '../../services/reports.service';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'grid-custom-report-download-button',
  template: `
    <span>
      <button
        mat-button
        vrm-button
        fxFlex
        class="grid-text-centred force grid-text"
        style="color: white"
        (click)="triggerLinkButtonAction()"
      >
        {{ value }}
      </button>
    </span>
  `,
  styles: [],
})
export class GridCustomReportDownloadButtonComponent implements ICellRendererAngularComp {
  public value: string;

  constructor(private cService: CommonService, public rptService: ReportsService) {}

  agInit(params: { value: any }) {
    this.value = params.value;
  }

  triggerLinkButtonAction() {
    setTimeout(() => {
      const reportData = this.getReportData();

      if (reportData) {
        reportData.subscribe((response) => {
          const payloadSize = response.size;

          if (payloadSize == 0) {
            this.cService.showToast(this.cService.readyTranslations.customReport.noDataReceivedCustomCSV, 3000);
          } else {
            this.downloadFile(response, response.type);
          }
        });
      } else {
        this.cService.showToast(this.cService.readyTranslations.customReport.noDataReceivedCustomCSV, 3000);
      }
    }, 150);
  }

  private getReportData(): Observable<any> | null {
    let reportId = null;

    if (this.rptService.selectedRows[0]) {
      reportId = this.rptService.selectedRows[0].reportId;
    }

    return reportId ? this.rptService.getDownloadableReportDataFromServer(reportId) : null;
  }

  private downloadFile(data: any, fileType: string) {
    const filename = this.generateFileName();
    const blob = new Blob([data], { type: fileType });

    const link = document.createElement('a');
    if (!link.download) {
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }

  private generateFileName() {
    const months = ['jan', 'feb', 'mar', 'apr', 'may', 'jun', 'jul', 'aug', 'sep', 'oct', 'nov', 'dec'];
    const today = new Date();
    const month = months[today.getMonth()];

    const y = today.getFullYear();
    const m = this.cService.readyTranslations.generic[month];
    const d = today.getDate();

    const reportName = this.rptService.selectedRows[0].reportName;

    const fileName = this.cService.replaceSpecialChars(reportName);
    return `${fileName}_${y}_${m}_${d}.csv`;
  }

  refresh() {
    return false;
  }
}
